import { styled, TextField } from '@mui/material';

export const Input = styled(TextField)(() => ({
  '& input': {
    caretColor: 'transparent',
    cursor: 'pointer',
  },
}));
